<input type="checkbox" id="findEntireWord" class="toolbarField" />
<label for="findEntireWord" class="toolbarLabel" data-l10n-id="pdfjs-find-entire-word-checkbox-label"> Whole words </label>
